<template>
  <svg
    class="ds-arrow-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <path d="M9 11.55L4.5 7.05L5.55 6L9 9.45L12.45 6L13.5 7.05L9 11.55Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'DsArrowDown'
}
</script>

<style scoped>
.ds-arrow-icon {
  display: block;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  color: inherit;
}
</style>